<template>
  <div class="d-flex main">
    <template v-if="complaintDescription">
      <div class="message-description-avatar mr-2 d-flex justify-center align-center" v-if="message.head">
        <img height="18" width="18" :src="require('@/assets/logo/reduced.svg')" alt="logo.svg" />
      </div>
      <div class="full-width d-inline-flex flex-column">
        <div class="full-width d-inline-flex justify-start" v-bind:class="{ mar: !message.head }">
          <div
            class="message-body message-description"
            v-bind:class="{ 'message-participant-tail': !message.last, 'message-participant-last': message.last }"
          >
            <div class="ma-3 ml-4 message-description-title">
              {{ $t("chat.visitReason") }}
            </div>
            <div class="message-description-line" />
            <div class="ma-3 ml-4">{{ message.body }}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="message.my">
      <div class="full-width d-inline-flex flex-column">
        <div v-if="message.head" class="full-width d-inline-flex justify-end mb-1">
          <span class="message-head">{{ message.time }}</span>
        </div>
        <div class="full-width d-inline-flex justify-end">
          <div
            class="pa-3 message-body message-my"
            v-bind:class="{ 'message-my-tail': !message.head, 'message-my-head': message.head }"
          >
            <v-chip v-if="message.raw.type === 'media'" color="primary" label small @click="openFile">
              {{ message.raw.media.filename }}
            </v-chip>
            <span v-else> {{ message.body }} </span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <Avatar v-if="message.head && message.author" :userId="message.author.uid" class="mr-2" size="28" />
      <div class="full-width d-inline-flex flex-column">
        <div v-if="message.head" class="full-width d-inline-flex justify-start mb-1">
          <span class="message-head">{{ message.name }}, {{ message.time }}</span>
        </div>
        <div class="full-width d-inline-flex justify-start" v-bind:class="{ mar: !message.head }">
          <div
            class="pa-3 message-body message-participant"
            v-bind:class="{ 'message-participant-tail': !message.last, 'message-participant-last': message.last }"
          >
            <v-chip v-if="message.raw.type === 'media'" color="primary" @click="openFile">
              {{ message.raw.media.filename }}
            </v-chip>
            <span v-else> {{ message.body }} </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";

import Avatar from "@/components/Avatar/Index";

export default Vue.extend({
  name: "Message",
  props: {
    message: Object,
  },
  components: {
    Avatar,
  },
  methods: {
    async openFile() {
      const url = await this.message.raw.media.getContentTemporaryUrl();
      window.open(url, "_blank");
    },
  },
  computed: {
    complaintDescription() {
      return this.message?.raw?.attributes?.complaintDescription;
    },
  },
});
</script>

<style scoped lang="scss">
.message {
  &-head {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: #bec5cc;
  }
  &-body {
    white-space: pre-line;
    display: inline-block;
    max-width: 80%;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.34px;
    color: #2f445c;
  }
  &-my {
    background: #dbf4fe;
    &-head {
      border-radius: 10px 10px 0 10px;
    }
    &-tail {
      border-radius: 10px 0 0 10px;
    }
  }
  &-participant {
    background: #f2f6f9;
    &-last {
      border-radius: 0 10px 10px 10px;
    }
    &-tail {
      border-radius: 0 10px 10px 0;
    }
  }
  &-description {
    border: 1px solid #f3f3f3;
    border-radius: 6px;
    &-title {
      font-size: 14px;
      line-height: 17px;
      display: flex;
      align-items: center;
      letter-spacing: 0.16px;
      color: #000000;
    }
    &-line {
      border-bottom: 1px solid #f3f3f3;
    }
    &-avatar {
      width: 26px;
      height: 26px;
      background: $primary;
      border-radius: 6px;
    }
  }
}
.main {
  margin-top: 8px;
  width: 100%;
}
.mar {
  margin-left: 33px;
}
</style>
